<div class="container">
    <div class="row">

        <div class="card text-dark  col-sm-4 bg-light">
            <div class="card-header">
                Insurance Details
            </div>
            <div class="card-body">

            </div>
        </div>


        <div class="p-0 card text-dark col-sm-4 bg-light">
            <div class="card-header">
            Apppointments
            </div>
            <div class="card-body p-0">
                <table class="table m-0 p-0  table-striped table-hover table-bordered"
                *ngIf='bookedSlots && bookedSlots.length'>
                    <thead class="thead thead-light">
                        <th >Date</th>
                        <th>Time</th>
                        <th >Staff  Name </th>
                    </thead>
                    <tbody>
                    <tr *ngFor ='let bookedSlot of bookedSlots'>
                        <td class='ml-0 p-1'>{{ bookedSlot.timeSlot.date}}</td>
                        <td class='m-0 p-1'> {{bookedSlot.timeSlot.startTime}} -{{bookedSlot.timeSlot.endTime}}</td>
                        <td class='m-0 p-1  text-capitalize'> {{bookedSlot.staff.firstName}} {{bookedSlot.staff.lastName}}</td>

                    </tr>
                    </tbody>
                </table>


                <div  class="row" *ngIf='isSchedule'>
                    <div class='col-sm-4 m-0 pr-1 pt-1 pb-1'>
                        <div class='form-group'>
                            <label class="mb-0 small" for="date">Date</label>
                            <input   type="date"  class=" form-control"  data-date-format="MM-dd-yyyy" [(ngModel)]='dateAppointment'>
                         </div>
                    </div>

                    <div class='col-sm-4 m-0 p-1'>
                        <div class='form-group'>
                            <label class="mb-0" for="Staff">Staff</label>
                            <select   class=" form-control" [(ngModel)]='staffId'>
                                <option value='1'>Dr Lavenia Taneja</option>
                            </select>
                        </div>
                    </div>

                    <div class='col-sm-4 mt-4 p-1'>

                            <button  (click)="getCalender()" class="btn m-0 p-0 btn-success form-control">Check Avail</button>
                    </div>
                </div>

                    <table class="table   table-striped table-hover table-bordered"
                    *ngIf='calenderResponse && calenderResponse.length'>
                        <thead class="thead thead-light">
                            <th >Date</th>
                            <th>Time</th>
                            <th >Patient  Name </th>
                        </thead>
                        <tbody>
                        <tr *ngFor ='let calenderRes of calenderResponse'>
                            <td class='ml-0 p-1'>{{ dateAppointment}}</td>
                            <td class='m-0 p-1'> {{calenderRes.startTime}} -{{calenderRes.endTime}}</td>
                            <td class='m-0 p-1  text-capitalize'> {{calenderRes.patientFirstName}} {{calenderRes.patientLastName}}</td>

                        </tr>
                        </tbody>
                    </table>


                    <div  class="row" *ngIf='isSchedule'>
                        <div class='col-sm-4 m-0 pr-1 pt-1 pb-1'>
                            <div class='form-group'>
                                <label class="mb-0 small" for="date">Start time</label>
                                <input type="time" id="appst" name="appst"  [(ngModel)]= 'startTime' required>
                             </div>
                        </div>

                        <div class='col-sm-4 m-0 p-1'>
                            <div class='form-group'>
                                <label class="mb-0" for="Staff">End time</label>
                                <input type="time" id="appet" name="appet"  [(ngModel)]= 'endTime' required>
                            </div>
                        </div>

                        <div class='col-sm-4 mt-4 p-1'>

                                <button id='bookAppButton' (click)="bookAppointment()" class="btn m-0 p-0 btn-success form-control">Book</button>
                        </div>
                    </div>


            </div>
        </div>

        <div class="card text-dark col-sm-4 bg-light">
            <div class="card-header">
            Treatment
            </div>
            <div class="card-body">
            </div>
        </div>
    </div>
</div>
